import type { InjectionKey, Ref } from 'vue'
import type {
  CollapseActiveName,
  CollapseExpandIconPosition,
} from './collapse'

export interface CollapseContext {
  activeNames: Ref<CollapseActiveName[]>
  handleItemClick: (name: CollapseActiveName) => void
  expandIconPosition: Ref<CollapseExpandIconPosition>
}

export const collapseContextKey: InjectionKey<CollapseContext> =
  Symbol('collapseContextKey')